// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// @ts-ignore
import {default as version} from '../../version.json';

export const environment = {
    production: false,
    configDebug: false,
    appVersion: require('../../package.json').version,
    validProducts: [
        'VitalityCheck',
        'VitalityCheckMLM',
        'KHACHIKchecker',
        'VEGEcheck',
        'PHYTOscan',
    ],
    appDesignConfigs: undefined,
    appDesignSettings: undefined,
    appDesignLanguages: undefined,
    appDesignName: undefined,
    appConfigUrl: [
        'https://api-de.biozoom.net',
        'https://api-ca.biozoom.net',
        'https://api-jp1.biozoom.net',
    ],
    appLicenseUrl: [
      'https://userapi.biozoom.net'
    ],
    config: {
        product: 'biozoom',
        shouldUpgrade: false, // Legacy: not used by pipeline updates.
        shouldUpgradeESP: false,
        appName: 'VitalityCheck',
        defaultLang: 'EN-US',
        resultBaseUrl: 'https://server.biozoom.org/vitality-report/overview',
        wifiPrefixUrl: 'https://update.biozoom.net/wifi-prefix',
        updateUrl: 'https://update.biozoom.net/update',
        updateUser: 'biozoom',
        updatePassword: 'una0Churiphahghaedae',
        upgradeUser: 'admin',
        upgradePassword: 'e2gEif6QqLcIS8Yuc08d',
        measurementUrl: 'https://server.biozoom.org/measurement_derma/service/measurement.html',
        measurementHrvUrl: 'https://server.biozoom.org/measurement_derma/service/measurement_hrv.html',
        testConnectionUrl: 'https://server.biozoom.org/measurement_derma/service/testConnection',
        vwsPrerequestUrl: '/pre-request/',
        vwsMeasurementUrl: '/measure/',
        vwsBaseUrls: [
            'https://vws1.biozoom.org',
            'https://vws2.biozoom.org',
            'https://vws3.biozoom.org',
            // Alte mybiozoom.de-VWS: vorläufig deaktiviert, nicht entfernen.
            // 'https://vws1.mybiozoom.de',
            // 'https://vws2.mybiozoom.de',
            // 'https://vws3.mybiozoom.de',
        ],
        validProducts: [],
    },
  settings: {
    handRecognitionLimitDarkUpper: 100,
    handRecognitionLimitBrightLower: 300,
    handRecognitionLimitBrightUpper: 1200,
    batteryCutoffVoltage: 3.666,
    batteryPrewarningVoltage: 3.746,

  },
  media: {},
  appDesignTemplates: undefined,
  appDesignTemplatesElements: undefined

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
